import { useEffect, useState } from "react";

import Login from "./pages/Login";
import ShopLogin from "./pages/ShopLogin";
import StaffShift from "./pages/StaffShift";
import Admin from "./pages/Admin";
import Attendance from "./pages/Attendance";
import { apiUrl } from "./utils/api";

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(() => {
    return localStorage.getItem("shopToken") ? "login" : "shop-login";
  });
  // =========================
  // ログイン確認
  // =========================
  useEffect(() => {
    const checkLogin = async () => {
      const token = localStorage.getItem("token");
      // token無し
      if (!token) {
        setLoading(false);
        return;
      }
      try {
	        const res = await fetch(
	          apiUrl("/me"),
          {
            headers: {Authorization: `Bearer ${token}`,
            },
          }
        );

        // token無効
        if (!res.ok) {
          localStorage.clear();
          setLoading(false);
          return;
        }
        const data = await res.json();
        // user形式統一
        setUser({
          id: data.id,
          employeeId:data.employee_id,
          name:data.name,
          hourlyWage:data.hourly_wage,
          transportationFee:data.transportation_fee,
          isAdmin:data.is_admin,
        });
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    checkLogin();
  }, []);

  // =========================
  // ローディング
  // =========================
  if (loading) {
    return (
      <div> Loading...</div>
    );
  }


  // =========================
  // 未ログイン
  // =========================
  if (!user) {
    if (page === "shop-login") {
      return <ShopLogin setPage={setPage} />;
    }
    return <Login setUser={setUser} setPage={setPage} />;
  }
  // =========================
  // 出退勤管理 
  // =========================
  if (page === "attendance") {
  return (
    <Attendance setPage={setPage}/>
  );
}

  // =========================
  // 管理者
  // =========================
  if (user.isAdmin === true) {

    return (
      <Admin setUser={setUser} setPage={setPage}/>
    );
  }

  // =========================
  // 一般ユーザー
  // =========================
  return (
    <StaffShift setUser={setUser} setPage={setPage}/>
  );
}

export default App;
